/* tslint:disable */
/* eslint-disable */
/**
 * Haltian API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Device ThingGroup object
 * @export
 * @interface ThingDeploymentGroup
 */
export interface ThingDeploymentGroup {
    /**
     * Group ID
     * @type {string}
     * @memberof ThingDeploymentGroup
     */
    group_id: string;
    /**
     * Group description
     * @type {string}
     * @memberof ThingDeploymentGroup
     */
    group_description: string;
}

export function ThingDeploymentGroupFromJSON(json: any): ThingDeploymentGroup {
    return ThingDeploymentGroupFromJSONTyped(json, false);
}

export function ThingDeploymentGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThingDeploymentGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group_id': json['group_id'],
        'group_description': json['group_description'],
    };
}

export function ThingDeploymentGroupToJSON(value?: ThingDeploymentGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group_id': value.group_id,
        'group_description': value.group_description,
    };
}


